import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import "./App.css";
import NewsSource from "./NewsSource";
import Individual from "./Individual";
import Navigation from "./Navigation";
import TopStories from "./TopStories";
import newsBanner from "./NewsBanner.jpg";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navigation />
        <Route exact path="/">
          <img src={newsBanner} style={{ width: "100%" }} />
          <Individual title="Top Stories" />
        </Route>
        <Route path="/individual">
          <Individual title="Associated Press" />
        </Route>
        <Route path="/axios">
          <Individual title="Axios" />
        </Route>
        <Route path="/abc-news">
          <Individual title="ABC News" />
        </Route>
        <Route path="/associated-press">
          <Individual title="Associated Press" />
        </Route>
        <Route path="/bbc-news">
          <Individual title="BBC News" />
        </Route>
        <Route path="/bleacher-report">
          <Individual title="Bleacher" />
        </Route>
        <Route path="/bloomberg">
          <Individual title="Bloomberg" />
        </Route>
        <Route path="/breitbart-news">
          <Individual title="Breitbart" />
        </Route>
        <Route path="/business-insider">
          <Individual title="Business Insider" />
        </Route>
        <Route path="/buzzfeed">
          <Individual title="Buzzfeed" />
        </Route>
        <Route path="/cbc-news">
          <Individual title="CBC News" />
        </Route>
        <Route path="/cbs-news">
          <Individual title="CBS News" />
        </Route>
        <Route path="/cnn">
          <Individual title="CNN" />
        </Route>
        <Route path="crypto-coins-news">
          <Individual title="Crypto Coins News" />
        </Route>
        <Route path="/engadget">
          <Individual title="Engadget" />
        </Route>
        <Route path="/entertainment-weekly">
          <Individual title="Entertainment Weekly" />
        </Route>
        <Route path="/espn">
          <Individual title="ESPN" />
        </Route>
        <Route path="/financial-post">
          <Individual title="Financial Post" />
        </Route>
        <Route path="/fortune">
          <Individual title="Fortune" />
        </Route>
        <Route path="/fox-news">
          <Individual title="Fox News" />
        </Route>
        <Route path="/fox-sports">
          <Individual title="Fox Sports" />
        </Route>
        <Route path="/google-news">
          <Individual title="Google News" />
        </Route>
        <Route path="/hacker-news">
          <Individual title="Hacker News" />
        </Route>
        <Route path="/ign">
          <Individual title="IGN" />
        </Route>
        <Route path="/independent">
          <Individual title="Independent" />
        </Route>
        <Route path="/mashable">
          <Individual title="Mashable" />
        </Route>
        {/* <Route path="/medical-news-today">
          <Individual title="Medical News Today" />
        </Route> */}
        <Route path="/msnbc">
          <Individual title="MSNBC" />
        </Route>
        <Route path="/mtv-news">
          <Individual title="MTV News" />
        </Route>
        {/* <Route path="/national-geographic">
          <Individual title="National Geographic" />
        </Route> */}
        <Route path="/national-review">
          <Individual title="National Review" />
        </Route>
        <Route path="/nbc-news">
          <Individual title="NBC News" />
        </Route>
        <Route path="/news24">
          <Individual title="News24" />
        </Route>
        <Route path="/new-scientist">
          <Individual title="New Scientist" />
        </Route>
        {/* <Route path="/news-com-au">
          <Individual title="News.com.au" />
        </Route> */}
        {/* <Route path="/newsweek">
          <Individual title="Newsweek" />
        </Route> */}
        <Route path="/new-york-magazine">
          <Individual title="New York Magazine" />
        </Route>
        {/* <Route path="/nfl-news">
          <Individual title="NFL News" />
        </Route>
        <Route path="/nhl-news">
          <Individual title="NHL News" />
        </Route> */}
        <Route path="/politico">
          <Individual title="Politico" />
        </Route>
        <Route path="/polygon">
          <Individual title="Polygon" />
        </Route>
        <Route path="/recode">
          <Individual title="Recode" />
        </Route>
        <Route path="/reddit-r-all">
          <Individual title="Reddit" />
        </Route>
        <Route path="/reuters">
          <Individual title="Reuters" />
        </Route>
        <Route path="/rt">
          <Individual title="RT" />
        </Route>
        <Route path="/rte">
          <Individual title="RTE" />
        </Route>
        <Route path="/techcrunch">
          <Individual title="TechCrunch" />
        </Route>
        <Route path="/techradar">
          <Individual title="TechRadar" />
        </Route>
        <Route path="/the-american-conservative">
          <Individual title="The American Conservative" />
        </Route>
        <Route path="/the-globe-and-mail">
          <Individual title="The Globe And Mail" />
        </Route>
        <Route path="/the-hill">
          <Individual title="The Hill" />
        </Route>
        <Route path="/the-hindu">
          <Individual title="The Hindu" />
        </Route>
        <Route path="/the-next-web">
          <Individual title="The Next Web" />
        </Route>
        <Route path="/the-times-of-india">
          <Individual title="Times of India" />
        </Route>
        <Route path="/the-verge">
          <Individual title="Verge" />
        </Route>
        <Route path="/the-wall-street-journal">
          <Individual title="Wall Street Journal" />
        </Route>
        <Route path="/washington-post">
          <Individual title="Washington Post" />
        </Route>
        <Route path="/time">
          <Individual title="Time" />
        </Route>
        <Route path="/usa-today">
          <Individual title="USA Today" />
        </Route>
        <Route path="/vice">
          <Individual title="Vice" />
        </Route>
        <Route path="/wired">
          <Individual title="Wired" />
        </Route>
        <Route path="/the-wall-street-journal">
          <Individual title="Wall Street Jouranl" />
        </Route>
        <Route path="/populate">
          <NewsSource title="Axios" id="axios" />
          <NewsSource title="ABC News" id="abc-news" />
          <NewsSource title="Associated Press" id="associated-press" />
          <NewsSource title="BBC News" id="bbc-news" />
          {/* <NewsSource title="BBC Sports" id="bbc-sport" /> */}
          <NewsSource title="Bleacher" id="bleacher-report" />
          <NewsSource title="Bloomberg" id="bloomberg" />
          <NewsSource title="Breitbart" id="breitbart-news" />
          <NewsSource title="Business Insider" id="business-insider" />
          <NewsSource title="Buzzfeed" id="buzzfeed" />
          <NewsSource title="CBC News" id="cbc-news" />
          <NewsSource title="CBS News" id="cbs-news" />
          <NewsSource title="CNN" id="cnn" />
          {/* <NewsSource title="Crypto Coins News" id="crypto-coins-news" /> */}
          <NewsSource title="Engadget" id="engadget" />
          <NewsSource title="Entertainment Weekly" id="entertainment-weekly" />
          <NewsSource title="ESPN" id="espn" />
          <NewsSource title="Financial Post" id="financial-post" />
          <NewsSource title="Fortune" id="fortune" />
          <NewsSource title="Four Four Two" id="four-four-two" />
          <NewsSource title="Fox News" id="fox-news" />
          <NewsSource title="Fox Sports" id="fox-sports" />
          <NewsSource title="Google News" id="google-news" />
          <NewsSource title="Hacker News" id="hacker-news" />
          <NewsSource title="CBS News" id="cbs-news" />
          <NewsSource title="IGN" id="ign" />
          <NewsSource title="Independent" id="independent" />
          <NewsSource title="Mashable" id="mashable" />
          {/* <NewsSource title="Medical News Today" id="medical-news-today" /> */}
          <NewsSource title="MSNBC" id="msnbc" />
          <NewsSource title="MTV News" id="mtv-news" />
          <NewsSource title="National Geographic" id="national-geographic" />
          <NewsSource title="National Review" id="national-review" />
          <NewsSource title="NBC News" id="nbc-news" />
          <NewsSource title="News24" id="news24" />
          <NewsSource title="New Scientist" id="new-scientist" />
          {/* <NewsSource title="News.com.au" id="news-com-au" /> */}
          {/* <NewsSource title="Newsweek" id="newsweek" /> */}
          <NewsSource title="New York Magazine" id="new-york-magazine" />
          {/* <NewsSource title="Next Big Future" id="next-big-future" /> */}
          <NewsSource title="NFL News" id="nfl-news" />
          <NewsSource title="NHL News" id="nhl-news" />
          <NewsSource title="Politico" id="politico" />
          <NewsSource title="Polygon" id="polygon" />
          <NewsSource title="Recode" id="recode" />
          <NewsSource title="Reddit" id="reddit-r-all" />
          <NewsSource title="Reuters" id="reuters" />
          <NewsSource title="RT" id="rt" />
          <NewsSource title="RTE" id="rte" />
          <NewsSource title="TechCrunch" id="techcrunch" />
          <NewsSource title="TechRadar" id="techradar" />
          <NewsSource
            title="The American Conservative"
            id="the-american-conservative"
          />
          <NewsSource title="The Globe And Mail" id="the-globe-and-mail" />
          <NewsSource title="The Hill" id="the-hill" />
          <NewsSource title="The Hindu" id="the-hindu" />
          <NewsSource title="The Next Web" id="the-next-web" />
          <NewsSource title="Times of India" id="the-times-of-india" />
          <NewsSource title="Verge" id="the-verge" />
          <NewsSource
            title="Wall Street Journal"
            id="the-wall-street-journal"
          />
          <NewsSource title="Washington Post" id="the-washington-post" />
          <NewsSource title="Time" id="time" />
          <TopStories title="Top Stories" />
          <NewsSource title="USA Today" id="usa-today" />
          <NewsSource title="Vice" id="vice-news" />
          <NewsSource title="Wired" id="wired" />
        </Route>
      </BrowserRouter>
    </>
  );
}

export default App;
